export default {
      id: "cd-check-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#cd-check",
      toString: function () {
        return this.url;
      }
    }